<template>
    <RegularModal ref="modal">
        <template v-slot:title>
            <h4 class="modal-title">{{ translate("timezone_picker.choose") }}</h4>
        </template>

        <template v-slot:body>
            <div class="field">
                <input type="text" class="input" :placeholder="translate('common.find')" v-model="searchQuery" />
            </div>
            <div class="field">
                <div class="timezone-select select is-fullwidth">
                    <select size="10" v-model="internalValue">
                        <option v-for="timezone in filteredTimezones" :key="timezone">
                            {{ timezone }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="field">
                <div>
                    {{ translate("timezone_picker.your_choice") }} <strong>{{ internalValue }}</strong>
                </div>
                <div>{{ translate("timezone_picker.current_time") }} {{ timeByTimezone }}</div>
            </div>
        </template>

        <template v-slot:footer>
            <div class="buttons">
                <button @click="confirm" class="button is-primary">OK</button>
                <button @click="close" class="button">
                    {{ translate("common.close") }}
                </button>
            </div>
        </template>
    </RegularModal>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";
    import timezones from "./timezones";
    import objectMatcher from "../Common/objectMatcher";
    import { getLocale } from "../Common/locale";
    import RegularModal from "../Common/RegularModal";

    export default {
        name: "timezone-picker",
        components: {
            RegularModal,
        },
        mixins: [translatorMixin],
        props: ["modelValue"],
        data() {
            return {
                timezones: [],
                searchQuery: "",
                internalValue: "",
            };
        },
        computed: {
            filteredTimezones() {
                return this.timezones.filter(timezone => {
                    return objectMatcher.matchString(this.searchQuery, timezone);
                });
            },
            timeByTimezone() {
                if (!this.internalValue) {
                    return "";
                }

                const d = new Date();
                return d.toLocaleString(getLocale(), {
                    timeZone: this.internalValue || this.modelValue,
                    hour12: false,
                });
            },
        },
        methods: {
            open() {
                this.searchQuery = "";
                this.timezones = timezones.sort();
                this.internalValue = this.modelValue;
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
            confirm() {
                this.$emit("update:modelValue", this.internalValue);
                this.$refs.modal.close();
            },
        },
    };
</script>

<style scoped>
    .timezone-select {
        height: 200px;
    }

    .timezone-select select {
        height: 200px;
    }
</style>
